import { Blog } from "@/payload-types";

export type SortValue = "published-desc" | "published-asc" | "title-asc" | "title-desc";

export type QueryBlogsResult = {
	docs: Partial<Blog>[];
	page: number;
	totalPages: number;
	totalDocs: number;
};

export const DEFAULT_BLOG_SORT: SortValue = "published-desc";

export const sortMap: Record<SortValue, string> = {
	"published-desc": "-publishedAt",
	"published-asc": "publishedAt",
	"title-asc": "title",
	"title-desc": "-title",
};

/**
 * Checks if a sort query value is one of the supported options.
 *
 * @param value - Raw sort value from search params.
 * @returns True when the value is a valid blog sort option.
 */
export function isSortValue(value: string | undefined): value is SortValue {
	return typeof value === "string" && value in sortMap;
}
